/* Pinnacle Garage USA - newsletter popup (sections/pg-newsletter-popup.liquid) */
(function () {
  var box = document.getElementById('pgnl'), tab = document.getElementById('pgnl-tab');
  if (!box || !tab) return;
  var S = sessionStorage, L = localStorage;
  function get(st, k) { try { return st.getItem(k); } catch (e) { return null; } }
  function set(st, k, v) { try { st.setItem(k, v); } catch (e) {} }
  var claimed = get(L, 'pgNlClaimed') === '1';
  var form = document.getElementById('pgnl-form'), err = box.querySelector('[data-pgnl="err"]');
  var start = box.querySelector('[data-pgnl="start"]'), done = box.querySelector('[data-pgnl="done"]');
  var BTN = box.getAttribute('data-btn') || 'Unlock My 5% Code';
  var lastFocus = null;

  /* car rotation: a different car every time the popup opens after being closed (remembered per browser) */
  var media = box.querySelector('[data-pgnl="media"]'), CARS = [];
  try { CARS = JSON.parse(document.getElementById('pgnl-cars').textContent) || []; } catch (e) {}
  var ci = parseInt(get(L, 'pgNlCar'), 10); if (isNaN(ci) || ci < 0) ci = 0;
  function showCar() {
    if (!CARS.length || !media) return;
    var c = CARS[ci % CARS.length];
    media.style.backgroundImage = "url('" + c.u + "')";
    media.style.setProperty('--pos', c.p); media.style.setProperty('--posm', c.m);
    media.setAttribute('aria-label', c.a);
    var nx = CARS[(ci + 1) % CARS.length]; if (nx && nx !== c) { var im = new Image(); im.src = nx.u; }
  }
  function nextCar() { if (!CARS.length) return; ci = (ci + 1) % CARS.length; set(L, 'pgNlCar', String(ci)); }
  showCar();

  function open() {
    lastFocus = document.activeElement;
    showCar();
    box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-in'); }); });
    setTimeout(function () { box.classList.add('is-in'); }, 80);
    document.documentElement.style.overflow = 'hidden';
    tab.classList.remove('is-on');
    setTimeout(function () { var f = box.querySelector(done.hidden ? 'input[type="email"]' : '.pgnl__btn'); if (f && window.innerWidth > 749) f.focus(); }, 350);
  }
  function close() {
    if (!box.classList.contains('is-open')) return;
    box.classList.remove('is-in'); box.setAttribute('aria-hidden', 'true');
    setTimeout(function () { box.classList.remove('is-open'); }, 300);
    document.documentElement.style.overflow = '';
    if (!claimed && get(S, 'pgNlTabHidden') !== '1') tab.classList.add('is-on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    nextCar();
  }
  function success() {
    claimed = true; set(L, 'pgNlClaimed', '1');
    start.hidden = true; done.hidden = false; err.textContent = '';
    tab.classList.remove('is-on');
  }

  box.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pgnl]'); if (!a) return;
    var k = a.getAttribute('data-pgnl');
    if (k === 'close') close();
    if (k === 'copy') {
      var code = box.getAttribute('data-code');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { a.textContent = 'Copied!'; }, function () { a.textContent = code; });
    }
    if (k === 'shop') close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });
  tab.addEventListener('click', function (e) {
    if (e.target.closest('[data-pgnl="hidetab"]')) { e.stopPropagation(); tab.classList.remove('is-on'); set(S, 'pgNlTabHidden', '1'); return; }
    open();
  });

  /* newsletter signup: submit in the background; if Shopify asks for a human check, fall back to a normal submit */
  form.addEventListener('submit', function (e) {
    var email = form.querySelector('input[type="email"]').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { e.preventDefault(); err.textContent = 'Please enter a valid email address.'; return; }
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]'); btn.disabled = true; btn.textContent = 'One moment…';
    set(S, 'pgNlReturn', '1');
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok || /challenge/.test(r.url)) throw new Error('fallback');
        return r.text().then(function (html) {
          /* read Shopify's answer from the popup's own markup on the returned page */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var msg = doc.querySelector('#pgnl [data-pgnl="err"]');
          if (!doc.querySelector('#pgnl [data-pgnl-posted]') && msg && msg.textContent.trim()) throw { msg: msg.textContent.trim() };
          success();
        });
      })
      .catch(function (x) {
        if (x && x.msg) { btn.disabled = false; btn.textContent = BTN; err.textContent = x.msg; return; }
        form.submit();
      });
  });

  /* back from a normal (non-background) submit */
  if (box.querySelector('[data-pgnl-posted]') || (/[?&]customer_posted=true/.test(location.search) && get(S, 'pgNlReturn') === '1')) {
    success(); set(S, 'pgNlSeen', '1'); open(); return;
  }
  if (err.textContent.trim()) { set(S, 'pgNlSeen', '1'); open(); return; }

  if (claimed) return;
  if (get(S, 'pgNlSeen') === '1') { if (get(S, 'pgNlTabHidden') !== '1') tab.classList.add('is-on'); return; }
  set(S, 'pgNlSeen', '1');
  setTimeout(open, Math.max(0, +box.getAttribute('data-delay') || 0) * 1000);
})();

/* newsletter signups (popup + footer box): keep the customer where they were instead of jumping to the form */
(function () {
  function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector('input[name="contact[email]"]')) return;
    if (!/\/contact/.test(f.getAttribute('action') || '') || f.querySelector('textarea')) return;
    set('pgNlScroll', JSON.stringify({ p: location.pathname, y: window.pageYOffset || 0 }));
  }, true);
  if (!/[?&]customer_posted=true/.test(location.search)) return;
  var saved = null; try { saved = JSON.parse(get('pgNlScroll') || 'null'); } catch (e) {}
  var y = saved && saved.p === location.pathname ? (+saved.y || 0) : 0;
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
  var q = location.search.replace(/([?&])customer_posted=true(&|$)/, '$1').replace(/[?&]$/, '');
  try { history.replaceState(history.state, '', location.pathname + q); } catch (e) {}
  var stop = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, function () { stop = true; }, { once: true, passive: true }); });
  function go() { if (!stop) window.scrollTo(0, y); }
  go();
  document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', function () { go(); [60, 250, 600].forEach(function (t) { setTimeout(go, t); }); });
})();